<template>
  <div class="row">
    <div v-if="!turnoSeleccionado.id" class="col-md-12">
      <selector-turno
        v-model="turnoSeleccionado"
        :params-turnos="paramsTurnos"
        sort-by="hora"
      >
      </selector-turno>
    </div>
    <transition enter-active-class="animated fadeIn">
      <div v-if="turnoSeleccionado.id" class="col-md-12">
        <h3 class="m-b-lg text-center">
          {{ cabeceraVariacion }}
        </h3>
        <formulario-variacion
          :action-url="actionUrl"
          :inscripcion-id="idInscripcion"
          :turno-id="turnoSeleccionado.id"
          :tipos-permitidos="['ausencia', 'cambio_parada']"
        />
      </div>
    </transition>
  </div>
</template>

<script>

import { dateToTimeString } from '../../../libs/dates';
import SelectorTurno from './SelectorTurno.vue';
import FormularioVariacion from './FormularioVariacion.vue';

export default {
  components: { SelectorTurno, FormularioVariacion },
  props: {
    // Array de objetos con id de inscripcion y turno_id
    inscripcionesTurno: { type: Array, required: true },
    actionUrl: { type: String, required: true },
  },
  data() {
    return {
      turnoSeleccionado: {},
    };
  },
  computed: {
    paramsTurnos() {
      return {
        id: this.inscripcionesTurno.map((e) => e.turno_id),
      };
    },
    idInscripcion() {
      const inscripcion = this.inscripcionesTurno.find(
        (e) => (e.turno_id === this.turnoSeleccionado.id),
      );
      return inscripcion ? inscripcion.id : undefined;
    },
    cabeceraVariacion() {
      const texto = `
        ${this.turnoSeleccionado.ruta.nombre}
        ${this.turnoSeleccionado.nombre}
        ${dateToTimeString(this.turnoSeleccionado.hora)}
      `;
      return this.$I18n.t('variacion_para', { texto });
    },
  },
};
</script>
